import './helpers/publicPath';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router/immutable';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import dotenv from 'dotenv';

dotenv.config();

/* eslint-disable */
// We need to load the config before anything else.
import { __DEBUG__, APP_ENV, APP_ROOT_ELEMENT_ID, USE_SENTRY, SENTRY_DSN } from './config/constants';
/* eslint-enable */

import { createBrowserHistory } from 'history';

import {
  EntityMapperContext,
  enableDrupalLogging,
} from '@uncinc/react-drupal-core';

import blocksMapper from './mappers/blocks';
import nodeMapper from './mappers/node';
import paragraphMapper from './mappers/paragraphs';
import taxonomyMapper from './mappers/taxonomy';
import viewsMapper from './mappers/views';

import configureStore from './store';
import * as serviceWorker from './serviceWorker';
import App from './containers/App';

import './styles/main.scss';

// Don't log env for production
if (__DEBUG__) {
  console.log(`Running environment ${APP_ENV}`);
  console.log(process.env);
}

if (USE_SENTRY) {
  // create a new project and copy the DSN
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],
    attachStacktrace: true,
    tracesSampleRate: 1.0,
  });
}

const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL,
});

const store = configureStore(history);

enableDrupalLogging();

const entityTypeMapper = {
  blocks: blocksMapper,
  node: nodeMapper,
  paragraph: paragraphMapper,
  taxonomy: taxonomyMapper,
  view: viewsMapper,
};

const render = () => {
  const root = createRoot(document.getElementById(APP_ROOT_ELEMENT_ID));
  root.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <EntityMapperContext.Provider value={entityTypeMapper}>
          <App />
        </EntityMapperContext.Provider>
      </ConnectedRouter>
    </Provider>,
  );
};

render();

// Enable Webpack hot module replacement for components.
if (module.hot) {
  module.hot.accept('./containers/App', () => {
    render();
  });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
